
import { Watch, Mixins, Component, InjectReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import { getStoreConfig, saveStoreConfig, listBookStoreByType } from "@/api/booking";

import { cloneDeep } from "lodash";

import { StoreStatusEnum } from "@/enum/store.enum";

import { IStoreBookingConfig, IStoreBookingService, IStoreConfigInfo } from "@/types/booking";

import { ERuntimeType } from "@/enum/booking.enum";

import dayjs  from "dayjs";


@Component({ name: 'booking-components-bookingConfig',
    components: {
        ETable
    }
})
export default class BookingConfig extends Mixins(TablePagination, Resize) {
    @InjectReactive() currentTab!: string|number;
    @InjectReactive() merchantId!: string|number;

    tabListSurplusHeight = 20;

    storeStatusEnum = StoreStatusEnum;

    storeName = "";
    storeId = 0;
    selectStoreInfo: any = {};

    storeConfigInfo: IStoreConfigInfo = {
        bookConfig: {},
        services: [],
    };

    bookingFlag = false; // 总预约开关
    bookingRoomNum = 0; // 同时段可约房间数

    // time = [new Date(1997, 9, 12, 10, 0), new Date(1997, 9, 12, 21, 0)];
    bookStartTime = "10:00"
    bookEndTime = "21:00";

    allStoreList: Array<any> = [];
    storeList: Array<any> = [];

    tableData: Array<IStoreBookingService> = [];
    loading = false;

    saveLoading = false;

    ysbBaseColumns = [
        { label: "设备分类", prop: "deviceClassName" },
        { label: "服务显示名称", prop: "name" },
        { label: "服务时长（分钟）", prop: "runtime" },
        { label: "预约时间间隔", prop: "runtimeType" },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "可预约量", prop: "quantity", 'render-header': (h, { column, $index }) => {
            return h("div", [
                h('span',{ attrs: { class: "required-icon" } },['*']),
                h('span',{},[column.label]),
            ])
        } },
    ]

    merchantBaseColumns = [
        { label: "服务显示名称", prop: "name" },
        { label: "服务时长（分钟）", prop: "runtime" },
        { label: "预约开始时间", prop: "bookStartTime" },
        { label: "预约时间间隔", prop: "runtimeType" },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "可预约量", prop: "quantity", 'render-header': (h, { column, $index }) => {
            return h("div", [
                h('span',{ attrs: { class: "required-icon" } },['*']),
                h('span',{},[column.label]),
            ])
        } },
    ]

    pickerOptions= {
    }

    get columns() {
        return this.merchantId ? this.merchantBaseColumns : this.ysbBaseColumns;
    }

    mounted() {
        this.windowResize(300);
    }

    formatterTime() {
        if (!this.storeConfigInfo?.bookConfig?.bookStartTime) {
            return "-";
        }
        return dayjs(`1997-09-12 ${this.storeConfigInfo?.bookConfig?.bookStartTime}`).format("HH:mm");
    }

    getStoreList() {
        listBookStoreByType({ merchantId: this.merchantId || 0 }).then((res) => {
            this.allStoreList = res.data;
            this.storeList = res.data;
            if (!res.data.length) return;
            this.selectStoreInfo = this.storeList[0]
            this.storeId = this.selectStoreInfo.id;
            this.getStoreConfig(this.storeId)
        })
    }

    getStoreConfig(storeId: number) {
        this.loading = true;
        getStoreConfig(storeId).then((res) => {
            const { bookConfig = {}, services } = res.data;
            this.storeConfigInfo = {
                bookConfig, services
            };
            this.tableData = this.storeConfigInfo.services; // 设置服务list
            this.tableData.forEach(el => {
               el.quantity = el.quantity || 0;
            });
            this.bookingRoomNum = this.storeConfigInfo?.bookConfig?.maxServiceNum;
            this.bookingFlag = this.storeConfigInfo?.bookConfig?.bookSwtich || false;
            this.bookStartTime = dayjs(`1997-09-12 ${this.storeConfigInfo?.bookConfig?.bookStartTime || '10:00:00'}`).format("HH:mm")
            this.bookEndTime = dayjs(`1997-09-12 ${this.storeConfigInfo?.bookConfig?.bookEndTime || '21:00:00'}`).format("HH:mm")
        }).finally(() => {
            this.loading = false
        })
    }

    selectStore(store) {
        this.storeId = store.id;
        this.selectStoreInfo = store;
        this.getStoreConfig(this.storeId);
    }

    getRuntimeTypeDesc(runtimeType: ERuntimeType | null) {
        if (runtimeType == 1) return '30分钟';
        if (runtimeType == 2) return '1小时';
        return "";
    }

    save() {
        if (!this.checkConfig(true)) return;
        if (!this.handleTimeChange()) return;
        this.saveLoading = true;
        const params = {
            bookConfig: {
                bookSwtich: this.bookingFlag,
                maxServiceNum: this.bookingRoomNum,
                storeId: this.storeId,
                merchantId: this.merchantId || 0,
                bookStartTime: `${this.bookStartTime}:00`,
                bookEndTime: `${this.bookEndTime}:00`,
            },
            services: this.tableData.map((el) => ({ bookServiceId: el.bookServiceId, quantity: el.quantity, storeId: this.storeId }))
        }
        saveStoreConfig(params).then((res) => {
            this.getStoreConfig(this.storeId);
            this.$message.success("操作成功");
        }).finally(() => {
            this.saveLoading = false;
        })
        
    }

    parseTime(timeStr) {
      // 将 "HH:mm" 转换为分钟数，方便比较
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    }

    handleTimeChange() {
      if (!this.bookStartTime || !this.bookEndTime) {
        this.$message.error('请选择可预约时间段');
        return false;
      }
      if (this.bookStartTime && this.bookEndTime) {
        // 比较时间
        const start = this.parseTime(this.bookStartTime);
        const end = this.parseTime(this.bookEndTime);
        if (start > end) {
          this.$message.error('开始时间不能大于结束时间');
          return false;
        }
      }
      return true;
    }

    checkConfig(showMessage) {
        if (!this.bookingRoomNum && (this.bookingRoomNum != 0)) {
            showMessage && this.$message.error(this.merchantId ? "请输入最大服务数" : "请输入可预约房间数");
            return false;
        }
        const _list = this.tableData.filter((el) => el.quantity < 0);
        if (_list.length) {
            showMessage && this.$message.error("请输入可预约数量");
            return false;
        }
        return true;
    }

    @Watch("storeName", { immediate: true })
    filterStoreList(value: string) {
        if (!value) {
            this.storeList = cloneDeep(this.allStoreList);
            return;
        }
        const _list = this.allStoreList?.filter(el => el.storeName.toLocaleUpperCase().indexOf(value?.trim()?.toLocaleUpperCase()) > -1)
        this.storeList = cloneDeep(_list);
    }

    @Watch("currentTab", { immediate: true })
    getData() {
        if (this.currentTab != 2) return;
        this.storeName = "";
        this.getStoreList();
    }
}

